import styled from 'styled-components';

export const TittleAccordion = styled.p`
  color: #fff;
  font-size: 1.2em;
  font-style: normal;
  font-weight: bold;
  line-height: 1.5em;
`;

export const DEscriptionAccordion = styled.p`
  color: #0015C1;
  font-size: 1.5em;
  font-style: normal;
  font-weight: regular;
  line-height: 1.5em;

  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 425px) {
    font-size: 1em;
  }
`;

export const ContentList = styled.div`
  padding: 1em 0.5em;

  ul {
    li {
      margin: 1em 0;

      display: flex;
      align-items: center;
      gap: 8px;
      p {
        font-size: 1.1em;
        color: #fff;
      }
      strong {
        font-weight: bold;
      }
    }
  }
`;

export const Description = styled.p`
  color: #000;
  max-width: 90%;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5em;

  strong {
    font-weight: bold;
  }
`;

export const ContentQuestions = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1em;
  .BaSe--accordion {
    border-radius: 100px !important;
    width:100% ;
  }

  .BaSe--accordion-title-container {
    border-top-left-radius: 32px !important;
    border-top-right-radius: 32px !important;
  }

  @media (max-width: 425px) {
    .BaSe--accordion {
      border-radius: 40px !important;
      width:100% ;

    }
  }
`;
